<template>
    <div>
        <NotFound />
    </div>
</template>

<script>
import NotFound from "../components/not-found/NotFound.vue";

import { mapActions } from "vuex";
import "@/mixins";
import $ from "jquery";
export default {
    components: {
        NotFound,
    },

    methods: {
        ...mapActions(["setCurrentPage", "setBannerSettings"]),
        addPageStyles() {
            if (document.querySelector(".navbar-placeholder")) {
                $(".navbar").removeClass("is-transparent navbar-light");
                $(".navbar").addClass("navbar-faded");
                $(".navbar-item .button-signup ").removeClass("light-btn");
                $(".navbar-item .button-signup").addClass("primary-btn");
            }
        },

        setBannerStyles: function () {
            this.setBannerSettings({
                title: "404 - Page not found",
                prevLinkText: null,
                currentLinkText: null,
                description:
                    "Oopss! That page doesn't exist or may have been changed or removed. Also confirm that the url you entered is correct.",
                buttonUrl: null,
                imageUrl: require("../assets/img/banner/banner-1.png"),
            });
        },
    },

    mounted() {
        this.setCurrentPage(this.$router.history.current.name);

        this.addPageStyles();
        this.setBannerStyles();

        $(window).scroll(() => {
            this.addPageStyles();
            // $("#header").addClass("moove");
        });

        // $("#header").addClass("moove");
    },
};
</script>

<style scoped>
</style>
